import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-employee-payment",
  templateUrl: "./employee-payment.component.html",
  styleUrls: ["./employee-payment.component.css"],
})
export class EmployeePaymentComponent implements OnInit {
  selectedIds: number[] = [];
  totalAmount: number = 0;
  showCheckout: boolean = false;
  showLogs: boolean = false;
  shouldRecalculate: boolean = false;

  ngOnInit(): void {
    const state = history.state;
    if (state?.recalculate) {
      this.shouldRecalculate = true;
      const newState = { ...state };
      delete newState.recalculate;
      window.history.replaceState(newState, "");
    }

    const savedIds = localStorage.getItem("careplus_selected_ids");
    if (savedIds) {
      this.selectedIds = JSON.parse(savedIds);
      this.showCheckout = true;
    }
  }

  onCalculateAmount(ids: number[]) {
    this.selectedIds = ids;
    localStorage.setItem("careplus_selected_ids", JSON.stringify(ids));
    this.showCheckout = true;
    this.showLogs = false;
  }

  onCancelledByCheckout() {
    this.showCheckout = false;
    localStorage.removeItem("careplus_selected_ids");
  }

  onTotalAmountChange(amount: number) {
    this.totalAmount = amount;
    if (amount <= 0) {
      this.showCheckout = false;
      localStorage.removeItem("careplus_selected_ids");
    }
  }
}
